import * as React from 'react';
import { SVGProps } from 'react';

const IconClearSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM7.297 7.297a1 1 0 0 0 0 1.414L10.586 12l-3.294 3.294a1 1 0 1 0 1.414 1.414L12 13.414l3.293 3.293a1 1 0 0 0 1.415-1.414L13.414 12l3.29-3.289a1 1 0 0 0-1.415-1.414L12 10.586l-3.289-3.29a1 1 0 0 0-1.414 0Z"
    />
  </svg>
);
export default IconClearSizeM;
